import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import config from "../config";
import helpers from "../helpers";
import _ from "underscore";

export default function PeriodsHistogram(props) {
	const [periods50yearsHistogramData, setPeriods50yearsHistogramData] = useState(null);
	const [yearsHistogramData, setYearsHistogramData] = useState(null);
	const [periods50yearsMax, setPeriods50yearsMax] = useState(0);
	const [yearsMax, setYearsMax] = useState(0);
	const [viewMode, setViewMode] = useState('years'); // 'years' / '50years'

	const [searchParams, setSearchParams] = useSearchParams();

	const get50YearPeriodsMax = (data) => {
		let grouped = groupBy50YearPeriods(data);

		return _.max(Object.keys(grouped).map(key => grouped[key].document_count));
	}

	const groupBy50YearPeriods = (data) => {
		return data.reduce((acc, { year, document_count }) => {
			const period = Math.floor(year / 50) * 50; // Calculate period start
			if (!acc[period]) {
				acc[period] = { period, document_count: 0 };
			}
			acc[period].document_count += document_count;
			return acc;
		}, {});
	}

	const createYearsData = (data) => {
		let min = parseInt(_.min(Object.keys(props.sliderMarks)));
		let max = parseInt(_.max(Object.keys(props.sliderMarks)));

		let ret = [];

		let yearIndex = {};
		data.forEach(year => {
			yearIndex[year.year] = year;
		});

		let length = (max-min)+1;
		let allYears = Array.from({ length }, (_, i) => min + i * 1);

		return allYears.map(year => {
			if (yearIndex[year]) {
				return yearIndex[year];
			}
			else {
				return {
					year: year,
					document_count: 0
				}
			}
		});
	}

	useEffect(() => {
		fetch(config.apiRoot+'years?'+helpers.getApiParams(searchParams, ['timabil', 'sida']).concat('limit=1000').join('&'))
			.then(res => res.json())
			.then(json => {
				setPeriods50yearsHistogramData(groupBy50YearPeriods(json.results));
				setPeriods50yearsMax(get50YearPeriodsMax(json.results));
				setYearsHistogramData(createYearsData(json.results));
				setYearsMax(_.max(_.pluck(json.results, 'document_count')))
		});
	}, [searchParams]);
	
	const colorMap = (n, max) => {
		return 'hsl(20, 100%, '+((n == 0 ? 95 : 70)-(n/max*60))+'%)';
		//return 'hsl('+(n/max*255)+', 100%, 50%)';
	}
	
	return <div>

		<div className="flex w-full justify-around">
			{
				yearsHistogramData && yearsHistogramData.map((year, index) => <button key={index} className="group h-4 grow transition-all relative" 
					style={{
						backgroundColor: colorMap(year && year.document_count ? year.document_count : 0, yearsMax)
					}}
					onClick={() => {
						if (props.onSelect) {
							props.onSelect([parseInt(year.year), parseInt(year.year)]);
						}
					}}
				>
					<div className="absolute -top-5 pointer-events-none hidden group-hover:block text-xs -ml-4 text-gray-400">{year.year}&nbsp;({year.document_count})</div>
				</button>)
			}
		</div>

		<div className="flex w-full justify-around">
			{
				periods50yearsHistogramData && Object.keys(props.sliderMarks).slice(0, -1).map((mark, index) => <button key={index} className="h-4 grow border-2 border-transparent hover:border-white/60 transition-all" 
					style={{
						backgroundColor: colorMap(periods50yearsHistogramData[mark] ? periods50yearsHistogramData[mark].document_count : 0, periods50yearsMax)
					}}
					onClick={() => {
						if (props.onSelect) {
							props.onSelect([parseInt(mark), parseInt(mark)+50]);
						}
					}}
				></button>)
			}
		</div>

	</div>
}